export const MAX_PROFILE_PICTURE_SIZE = 5 * 1024 * 1024;
export const PROFILE_PICTURE_ACCEPT = 'image/jpeg,image/png,image/webp';
const extensions = {
    'image/jpeg': /\.jpe?g$/i,
    'image/png': /\.png$/i,
    'image/webp': /\.webp$/i
};

export const validateProfilePicture = (file) => {
    if (!file) return 'Escolha uma imagem.';
    if (!extensions[file.type]?.test(file.name)) return 'Escolha uma imagem JPG, PNG ou WebP.';
    if (!file.size) return 'O ficheiro está vazio. Escolha outra imagem.';
    if (file.size > MAX_PROFILE_PICTURE_SIZE) return 'A imagem deve ter no máximo 5 MB.';
    return null;
};
